import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { Observable, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService, LoHiUserInfo } from '../auth.service';
import { InternalService } from '../internal.service';
declare let Headway: any;

@Component({
  selector: 'lohi-menu',
  templateUrl: './menu.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent implements OnInit, AfterViewInit {
  @Output() public closeMenu = new EventEmitter();
  public isInternal$: Observable<boolean>;
  public userInfo$: Observable<LoHiUserInfo>;
  public token$: Observable<string>;
  public isStage: boolean;
  constructor(private authService: AuthService, private internalService: InternalService) {}

  private headwayConfig = {
    selector: '#releaseNotesBadge', // CSS selector where to inject the badge
    trigger: '#releaseNotes',
    account: 'yoYMX7',
  };

  public ngOnInit(): void {
    this.userInfo$ = this.authService.userInfo$;
    this.isInternal$ = this.internalService.isInternal$;
    this.token$ = timer(0, 600000).pipe(switchMap(() => this.authService.customToken$));
    this.isStage = !environment.production;
  }

  public ngAfterViewInit(): void {
    if ((window as any).Headway) {
      Headway.init(this.headwayConfig);
    }
  }

  public logout() {
    this.authService.logout();
  }
}
